import { Component } from '@angular/core';
import { AuthService } from './authentication/services/auth.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiCallMethodsService } from './shared/services/api-call-methods.service';
import { apiRoutes } from './constants/apiRoutes';
import { SidenavThemeServiceService } from './shared/services/sidenav-theme-service/sidenav-theme-service.service';
import { ToggleServiceService } from './shared/services/toggle-service/toggle-service.service';
import { NgZone } from '@angular/core';
import Cookies from 'js-cookie';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  sidemenuChangeRoutes = ['/sales/business-management'];
  showSidemenu: any = true;
  sessionId = Cookies.get("sso_session");
  lastTS = Cookies.get("CB_GLOBAL_LOGOUT");

  constructor(public authService: AuthService,
    public router: Router,
    private modalService: NgbModal,
    private apiCallMethodsService: ApiCallMethodsService,
    private toggleService: ToggleServiceService,
    public themeService: SidenavThemeServiceService,
    private activatedRoute: ActivatedRoute,
    private zone: NgZone,
    private http: HttpClient
  ) {

    // let x = {
    //   "token": {
    //     "token": "eyJraWQiOiIvUDE1T3dXK3ArVnFuT2plK1M5dXZibmlabWNTajZ4b21OUlkxdlFPZzhzPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI2MTAzY2Q3YS05MDAxLTcwMmUtN2UxYi02ZTNkZjRhZjE4NjMiLCJpc3MiOiJodHRwczovL2NvZ25pdG8taWRwLmFwLXNvdXRoLTEuYW1hem9uYXdzLmNvbS9hcC1zb3V0aC0xX09nSzZwWlp4VSIsImNsaWVudF9pZCI6IjY3ZzdtcXE0YzJvZGdubjU2NnVxYW12bWpiIiwib3JpZ2luX2p0aSI6IjU0NmQ3NmQ1LWUwY2UtNGEyMi1iZjA1LTM2ZjI2MWVlM2JmMiIsImV2ZW50X2lkIjoiZTNhOTg3ODQtNjJiMC00YWUxLWFlMzMtZmExZGE1NTI0OTg3IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTc4NzExNjA2NywiZXhwIjoxNzg4MjQ0MDMyLCJpYXQiOjE3ODgxNTc2MzIsImp0aSI6ImU4NTA3NDM1LWM1MjAtNGVmMC05NmY2LTJmMjVmYTZiZjRkOSIsInVzZXJuYW1lIjoib3RwdGVzdGluZzA3XzhlOTg5OGVmIn0.WgzFjd9CizpeMOPLhauyne86wsUwFrrIXzHeSHcSAppVeq8SbMZoeKfH35f-ib9r1YfNMgI2V2vpATzMQS2Lr7Nep27hsmc41evKaRigzVF26GCDLxnUY2uaCDPHlnVlUdhqU7iJwb3tiKWPrbTzzWmEOCpcJp-Ub1QzX2crf_zr_d3OTAuiGqocOAl7hN2ogFcSpPjUb_rwrA6NSVOvCTViofG1P-jbRm1I6YS27vVeXvnXrHW7BTEHEBWlKoSDwBvlm20OtW1Eh0BQoalbeWeraFhhF3TK10c4CxCdU72V_oF8e7HazHn9phJ0a1qwJUdLxNZilgfm4pucJnypNw",
    //     "refreshToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.obGCYPnvpigKdPFrzMU_-inWv19oEbdfFtpYCVwAovnGC_ASNW2IX4R611kWDfjwkAX7IJUWsku-kpXBYwd0Gw0G_9nmp0QPknenGVjhDWwOHemLc7qfwhg3ZFmHlqAx6InVOUlchpJg_F3PcsLqwDvRF5rO3WjCBcqxicWWhJNkQL6aIFmKZKfRw7PxfkPfnCu4HHRjGbzNHkx4MvKc-KI6CYxfGha631Q4soxYM_ws4Br6EaNiV_u0RvAOCWyNvUSVMTJoRFJ3JxS4jrH5Q-bWCYmP87TBbSlAA2ZBmj_Edt31m6H04nUxoLLGjTtVltkqrRfLVFw4i8E8xLuTXA.oMtelo5t8SULILdR.j2EA52NnWnohJlO8II95R9AfO0CRkwxlxM810yAEErUB4Ue37qxdZZc0NvrkjTlNI4keTpJoPCFUQ8fudjcX4-Lg8gku0fXa2WO8YonXDdP0MuQ0r8_JsntbKTygXqyIQwduJ7_RmsFeHQk1fEtJgK8-zJwMoQ8JQ_QSxXUNgtS8czRoGEl7_3bantTG8eTFKXc5rg9y6q3EtEbXYdwEBwkUTv2-9cJLDun4zEeMOrKPALXIUmm4eq0wfPtJo_O8aPWYKqfp_pcu1CDrB02Wd2_f6KcYwYWVDHSm7dtuBy2zkDI4LCngbM92XUwqUuCM1TyAmrJXpyG1I_GBg88-Dm1IVGNVzxHW7ptsOFYsGI-rv7vIGVgfCPBq8fDLzMhKIsPX5sz69PhKbnmxehnglupnQv41ObgL4HP09jd7u7ZjI6wdNUcdArLk15uNEzWHXbAKQoBkLBa5su0owAIXw1qGGgoppDqmkSXRnFjUxSvSRmDFBsYRyqDZwtC9IzirtYD2gZFFrZuELy0YG0cKJgmI2WgG2uIA3Adf7GZO5YLZ-Mj2uRk0m6M0BvXdGvniUz-T4sNrM1Hm6MI8BNLf1p2_0F-gHPCF3n97TRL0zvsXmSLb3oXKx_qhO5e23XOUqmoVN4dbgtc9U_pXnmCB5xQma4pguVpob6T1C8rnMepR7rTQ8pTUztokat-YFwXUOpcMnNMCbbUmPx_uokYh5Q2Mc4jqb3aYHC9BBUEWrRMDfPffCo3T6L6ZL45uwxm9oR2tMI8Etj3R7Z2a1AvuSGygw4mlLki5BwJEBPzAf5sh2G0oRzkDejnunJ3zSmeuNYwo-wskhfurDbGciqKbQ0YcL-O0j5ej-cyAHX4DFXZyDWMF8MPIxm8iVTYSq8wcRHn2tc3EPai6xVfYkFJaDZaBHmiULU-0-phMnYfTEzmDxPqhJb9f9DovwGItQldjOi0ZSd2c6mCwtlgwclrLmMpU5driR5gIVku1J629bChRmRReayVlTRjJbYKRmlmNM07O88UMqny0O2wpApmwK3ooyXDM6qDSCfNZ2ZPtSOgccr0z36u5uyDtPA-ZlWEgmJJ6l_Kx5i8fxrvdb4en3cRAMxlIjOHdpLwxHybfw9J2psYsOMOXBHL70ZIGWnDzYr-jqxXYrN_Ebrr0_bTfgvwyXcbpkfElVyz8E3cnaqLW71rqeoQRaqwh7KhV5vAZOOyu5Q6cifUSADERUqzPkk_1-9Lm8CHQDjkJAXiQabQAE99pDEdTMeTuTJWQf0exdmlLXmbmkZbBbjIRzJf3d5k6i1hXkA.TbFrjAAZDr-LH97pmV3PmA",
    //     "expiresIn": 86400,
    //     "tokenType": "Bearer"
    //   },
    //   "user": {
    //     "name": "Rishi Ghosh",
    //     "email": "otptesting07@yopmail.com",
    //     "phone": "+918910274206",
    //     "org_id": "6a50d6f6b30a2a91a240e433",
    //     "user_id": "6a50d6e6b30a2a91a240e432",
    //     "cognito_username": "otptesting07_8e9898ef"
    //   }
    // }

    // this.authService.setToken(x);

    // this.authService.removeToken();
    // localStorage.removeItem('CSRF');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.modalService.dismissAll();
        let result = this.sidemenuChangeRoutes.find(x => event.url.toLowerCase().includes(x.toLowerCase()));
        this.showSidemenu = result ? false : true;
      }
    });
    this.toggleService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.modalService.dismissAll();
          let result = this.sidemenuChangeRoutes.find(x => event.url.toLowerCase().includes(x.toLowerCase()));
          this.showSidemenu = result ? false : true;
        }
      });
    });

    // this.authService.removeLoginDetails();
    // this.authService.removeToken();
    // this.authService.removeId();

    // setInterval(() => {
    //   const ts = Cookies.get("CB_GLOBAL_LOGOUT");

    //   if (ts && ts !== this.lastTS) {
    //     console.log('GLOBAL LOGOUT ABOUT TO BE TRIGGERED');
    //     this.lastTS = ts;
    //     this.performGlobalLogout();
    //   }
    // }, 1000);

  }

  performGlobalLogout() {
    console.log('GLOBAL LOGOUT TRIGGERED');

    this.authService.removeId();
    this.authService.removeToken();
    localStorage.removeItem('CSRF');

    // Remove shared SSO cookie
    Cookies.remove("sso_session", { domain: ".cloudbalance.in", path: "/" });

    let id = crypto.randomUUID();
    localStorage.setItem('CSRF', id);
    const baseUrl = window.location.origin;
  }

  isBlankPage(url: string): boolean {
    // Check if the current route is one of the specified routes
    const isAuthRoute = ['/auth/create-password'].some(route => url.includes(route));

    // Check if it's an authentication route with a token query parameter
    const hasToken = url.includes('/auth/create-password') && this.activatedRoute.snapshot.queryParams['token'];

    // Return true if it's one of the specified routes or an authentication route with a token
    return isAuthRoute || hasToken;
  }
  isToggled = false;

  toggleRightSidebarTheme() {
    this.themeService.toggleRightSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }

  toggleCardBorderTheme() {
    this.themeService.toggleCardBorderTheme();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggleCardBorderRadiusTheme() {
    this.themeService.toggleCardBorderRadiusTheme();
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }


  // performGlobalLogout() {
  //   // Remove Angular's session (localStorage)

  // }

  verifySession() {

    const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;

    const isFirstLoad = nav?.type === "reload" || nav?.type === "navigate";

    if (isFirstLoad) {

      // const cookie = Cookies.get("sso_session");
      let session = localStorage?.getItem('token');
      let sessionToken;

      if (session) {
        sessionToken = JSON.parse(session)?.token;
      }

      if (sessionToken?.token) {
        // console.log("Session exists:", session.token);

        let apiUrl = `admin/verify/session?product_client_id=cb-sales`;

        this.apiCallMethodsService.get(apiUrl).subscribe((response: any) => {
          if (response.success) {
            console.log('Session is valid!');
          }
          else {
            console.log('Session not valid: ', response);
            // this.authService.globalLogout();
          }
        }, (err: any) => {
          console.log('Session not valid: ', err);
          // this.authService.globalLogout();
        })

      } else {
        console.log("No Session found");
      }

    } else {
      // Do nothing for route changes
      console.log("Not a full reload → skipping cookie logic");
    }

  }

  /**
   * Loads the Release Notes micro frontend script so <cb-release-notes>
   * Web Component is registered and available globally.
   * The MFE must be running on http://localhost:5002 (npm run dev).
   *
   * The ReleaseNotesElement Web Component self-registers via customElements.define()
   * when the module loads — no explicit import() needed from Angular.
   */
  private loadReleaseNotesMFE(): void {
    const baseUrl = environment.releaseNotesUrl || 'http://localhost:5002';
    const cacheBuster = `?t=${Date.now()}`;
    const MFE_ENTRY = `${baseUrl}/assets/remoteEntry.js${cacheBuster}`;
    const ELEMENT_ENTRY = `${baseUrl}/assets/__federation_expose_ReleaseNotesElement.js${cacheBuster}`;

    if (document.querySelector(`script[src^="${baseUrl}/assets/__federation_expose_ReleaseNotesElement.js"]`)) return; // already injected

    // Load the federation entry first, then the element registrar
    const remoteScript = document.createElement('script');
    remoteScript.src = MFE_ENTRY;
    remoteScript.type = 'module';

    const elementScript = document.createElement('script');
    elementScript.src = ELEMENT_ENTRY;
    elementScript.type = 'module';
    elementScript.onerror = () =>
      console.warn(`[CB MFE] Release Notes remote is not reachable on ${baseUrl}.`);

    remoteScript.onload = () => document.head.appendChild(elementScript);
    remoteScript.onerror = () =>
      console.warn(`[CB MFE] Release Notes remoteEntry.js failed to load from ${baseUrl}.`);

    document.head.appendChild(remoteScript);
  }


  ngOnInit() {

    this.loadReleaseNotesMFE();

    this.authService.listenForLocalStorageLogout(() => {
      console.log('Local Storage Removed');
      this.router.navigate(['/']);
      location.reload();
    });

    // Guard: only verify session once per full page load.
    // Without this, verifySession() fires on every Angular route change,
    // which can trigger /session infinitely if there's a redirect loop.
    let hasVerifiedOnce = false;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {

        const currentUrl = event.urlAfterRedirects;
        console.log("Current URL:", currentUrl);

        if (currentUrl.includes('silent-logout')) {
          console.log('On silent logout → NO API CALL');
          return;
        }

        if (!hasVerifiedOnce) {
          hasVerifiedOnce = true;
          this.verifySession();
        }

        this.zone.run(() => {
          window.scrollTo(0, 0);
          console.log('scroll');
        });
      }
    });
  }


}
